export enum EmployeeType { // TODO refactor to string enum
  DESIGNER,
  LOCATION_PLANNING,
  PLACER,
  PRINTER,
  FINISHER,
  INVOICING,
  QUOTATION,
  EXTERNAL_SUPPLIER,
  IP_PLACER,
  ADHESIVE_PLACER,
  ATELIER,
}

export interface EmployeeTypeChoice {
  key: string;
  label: string;
}

export const EMPLOYEE_TYPE_CHOICE_ARRAY: EmployeeTypeChoice[] = [
  {
    key: 'IMMO_ADMIN',
    label: 'Immo admin',
  },
  {
    key: 'ATELIER',
    label: 'Atelier',
  },
  {
    key: 'DESIGNER',
    label: 'Design',
  },
  {
    key: 'LOCATION_PLANNING',
    label: 'Locatie/Planning',
  },
  {
    key: 'PLACER',
    label: 'Projectinstallateur',
  },
  {
    key: 'IP_PLACER',
    label: 'IP-installateur',
  },
  {
    key: 'ADHESIVE_PLACER',
    label: 'Kleefwerk',
  },
  {
    key: 'PRINTER',
    label: 'Drukker',
  },
  {
    key: 'FINISHER',
    label: 'Afwerking',
  },
  {
    key: 'INVOICING',
    label: 'Facturatie',
  },
  {
    key: 'QUOTATION',
    label: 'Offerte',
  },
  {
    key: 'EXTERNAL_SUPPLIER',
    label: 'Externe leveranciers',
  },
  {
    key: 'SITE_VISIT',
    label: 'Werfbezoek',
  },
];
